import { render, staticRenderFns } from "./TableCollapse1.vue?vue&type=template&id=007af7bc&scoped=true"
import script from "./TableCollapse1.vue?vue&type=script&lang=js"
export * from "./TableCollapse1.vue?vue&type=script&lang=js"
import style0 from "pretty-checkbox/dist/pretty-checkbox.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TableCollapse1.vue?vue&type=style&index=1&id=007af7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007af7bc",
  null
  
)

export default component.exports